import { getCookies } from 'cookies-next';

import HomePage from 'components/pages/Home';

import { resolvify } from 'lib/promises';
import { parseToBool } from 'lib/string';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getFeaturedOffersList, getRecentOffersList } from 'services/offer';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import COOKIES from 'constants/cookies';
import LINKS from 'constants/links';

const DESCRIPTION = 'Todas as ofertas do Promobit em ordem cronológica.';
const OFFERS_SERVER_LIMIT = 12;
const PAGE_TITLE = 'Ofertas recentes do Promobit';
const TAB_NAME = 'recents';

const Recents = ({
  cardsAds,
  cookieIsUserLogged,
  recoveryPassword,
  serverFeaturedOffers,
  serverOffers,
  smallAds,
}) => (
  <HomePage
    cardsAds={cardsAds}
    cookieIsUserLogged={cookieIsUserLogged}
    description={DESCRIPTION}
    pageTitle={PAGE_TITLE}
    recoveryPassword={recoveryPassword}
    serverFeaturedOffers={serverFeaturedOffers}
    serverOffers={serverOffers}
    smallAds={smallAds}
  />
);

export const getServerSideProps = async ({ query, req, res }) => {
  try {
    const [
      serverOffers,
      serverFeaturedOffers,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          cardAd: cardsAds = [],
          smallAd: smallAds = [],
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getRecentOffersList({ limit: OFFERS_SERVER_LIMIT, ...query }),
      { fn: getFeaturedOffersList(), fallback: getFeaturedOffersList.fallback },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    const { [COOKIES.IS_USER_LOGGED]: cookieIsUserLogged = false } = getCookies(
      { req, res }
    );

    return {
      props: {
        cardsAds,
        cookieIsUserLogged: parseToBool(cookieIsUserLogged),
        serverFeaturedOffers,
        serverOffers,
        smallAds,
        [APP.CTX_OPTIONAL_PROPS]: {
          activeOffersListTab: TAB_NAME,
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[500], permanent: false } };
  }
};

export default Recents;
